function getValueFromObject(obj, value, defaultValue = null) {
  return !!obj && !!obj[value] ? obj[value] : defaultValue;
}

module.exports = getValueFromObject;
